export default {
  /* Socket */

  SOCKET_STATUS_CHANGED: 'SOCKET_STATUS_CHANGED',
  SOCKET_DISCONNECT_HANDLE: 'SOCKET_DISCONNECT_HANDLE',
  SOCKET_RECONNECT_HANDLE: 'SOCKET_RECONNECT_HANDLE',
  SOCKET_RECONNECT_HANDLE__CORE_FETCH: 'SOCKET_RECONNECT_HANDLE__CORE_FETCH',
  ALERT_UPDATED: 'ALERT_UPDATED',
  ALERT_DISPLAYED: 'ALERT_DISPLAYED',

  /* Login */

  AUTHENTICATE: 'AUTHENTICATE',
  AUTHENTICATE_ERROR_CLEAR: 'AUTHENTICATE_ERROR_CLEAR',
  LOGOUT: 'LOGOUT',
  AUTHENTICATE_REQUESTED: 'AUTHENTICATE_REQUESTED',
  AUTHENTICATE_SUCCEEDED: 'AUTHENTICATE_SUCCEEDED',
  AUTHENTICATE_FAILED: 'AUTHENTICATE_FAILED',

  /* Core */

  CORE_INITIALIZED: 'CORE_INITIALIZED',

  /* Modal */

  MODAL_OPEN: 'MODAL_OPEN',
  MODAL_CLOSE: 'MODAL_CLOSE',

  /* Menu */

  TOGGLE_MENU: 'TOGGLE_MENU',
  TOGGLE_MENU_DESKTOP: 'TOGGLE_MENU_DESKTOP',
  CLOSE_MENU: 'CLOSE_MENU',
  TOGGLE_MODE: 'TOGGLE_MODE',

  /* Users */

  USERS_FETCH_REQUESTED: 'USERS_FETCH_REQUESTED',
  USERS_FETCH_SUCCEEDED: 'USERS_FETCH_SUCCEEDED',
  USERS_FETCH_FAILED: 'USERS_FETCH_FAILED',

  /* User */

  USER_CREATE: 'USER_CREATE',
  USER_CREATE_ERROR_CLEAR: 'USER_CREATE_ERROR_CLEAR',
  USER_UPDATE: 'USER_UPDATE',
  USER_EMAIL_UPDATE_ERROR_CLEAR: 'USER_EMAIL_UPDATE_ERROR_CLEAR',
  USER_PASSWORD_UPDATE_ERROR_CLEAR: 'USER_PASSWORD_UPDATE_ERROR_CLEAR',
  USER_USERNAME_UPDATE_ERROR_CLEAR: 'USER_USERNAME_UPDATE_ERROR_CLEAR',
  USER_DELETE: 'USER_DELETE',
  USER_TO_DEVICE_ADD: 'USER_TO_DEVICE_ADD',
  USER_FROM_DEVICE_REMOVE: 'USER_FROM_DEVICE_REMOVE',
  USER_TO_SITE_FILTER_ADD: 'USER_TO_SITE_FILTER_ADD',
  USER_FROM_SITE_FILTER_REMOVE: 'USER_FROM_SITE_FILTER_REMOVE',
  USER_CREATE_REQUESTED: 'USER_CREATE_REQUESTED',
  USER_CREATE_SUCCEEDED: 'USER_CREATE_SUCCEEDED',
  USER_CREATE_FAILED: 'USER_CREATE_FAILED',
  USER_CREATE_RECEIVED: 'USER_CREATE_RECEIVED',
  CURRENT_USER_FETCH_REQUESTED: 'CURRENT_USER_FETCH_REQUESTED',
  CURRENT_USER_FETCH_SUCCEEDED: 'CURRENT_USER_FETCH_SUCCEEDED',
  CURRENT_USER_FETCH_FAILED: 'CURRENT_USER_FETCH_FAILED',
  USER_UPDATE_REQUESTED: 'USER_UPDATE_REQUESTED',
  USER_UPDATE_SUCCEEDED: 'USER_UPDATE_SUCCEEDED',
  USER_UPDATE_FAILED: 'USER_UPDATE_FAILED',
  USER_UPDATE_RECEIVED: 'USER_UPDATE_RECEIVED',
  USER_EMAIL_UPDATE_REQUESTED: 'USER_EMAIL_UPDATE_REQUESTED',
  USER_EMAIL_UPDATE_SUCCEEDED: 'USER_EMAIL_UPDATE_SUCCEEDED',
  USER_EMAIL_UPDATE_FAILED: 'USER_EMAIL_UPDATE_FAILED',
  USER_PASSWORD_UPDATE_REQUESTED: 'USER_PASSWORD_UPDATE_REQUESTED',
  USER_PASSWORD_UPDATE_SUCCEEDED: 'USER_PASSWORD_UPDATE_SUCCEEDED',
  USER_PASSWORD_UPDATE_FAILED: 'USER_PASSWORD_UPDATE_FAILED',
  USER_USERNAME_UPDATE_REQUESTED: 'USER_USERNAME_UPDATE_REQUESTED',
  USER_USERNAME_UPDATE_SUCCEEDED: 'USER_USERNAME_UPDATE_SUCCEEDED',
  USER_USERNAME_UPDATE_FAILED: 'USER_USERNAME_UPDATE_FAILED',
  USER_AVATAR_UPDATE_REQUESTED: 'USER_AVATAR_UPDATE_REQUESTED',
  USER_AVATAR_UPDATE_SUCCEEDED: 'USER_AVATAR_UPDATE_SUCCEEDED',
  USER_AVATAR_UPDATE_FAILED: 'USER_AVATAR_UPDATE_FAILED',
  USER_DELETE_REQUESTED: 'USER_DELETE_REQUESTED',
  USER_DELETE_SUCCEEDED: 'USER_DELETE_SUCCEEDED',
  USER_DELETE_FAILED: 'USER_DELETE_FAILED',
  USER_DELETE_RECEIVED: 'USER_DELETE_RECEIVED',

  /* Diagram */

  DIAGRAM_FETCH_REQUESTED: 'DIAGRAM_FETCH_REQUESTED',
  DIAGRAM_FETCH_SUCCEEDED: 'DIAGRAM_FETCH_SUCCEEDED',
  DIAGRAM_FETCH_FAILED: 'DIAGRAM_FETCH_FAILED',

  /* Dashboard */

  DASHBOARD_FETCH_REQUESTED: 'DASHBOARD_FETCH_REQUESTED',
  DASHBOARD_FETCH_SUCCEEDED: 'DASHBOARD_FETCH_SUCCEEDED',
  DASHBOARD_FETCH_FAILED: 'DASHBOARD_FETCH_FAILED',

  /* Factories */

  FACTORIES_FETCH_REQUESTED: 'FACTORIES_FETCH_REQUESTED',
  FACTORIES_FETCH_SUCCEEDED: 'FACTORIES_FETCH_SUCCEEDED',
  FACTORIES_FETCH_FAILED: 'FACTORIES_FETCH_FAILED',

  /* Factory */

  FACTORY_CREATE: 'FACTORY_CREATE',
  FACTORY_UPDATE: 'FACTORY_UPDATE',
  FACTORY_DELETE: 'FACTORY_DELETE',
  FACTORY_CREATE_REQUESTED: 'FACTORY_CREATE_REQUESTED',
  FACTORY_CREATE_SUCCEEDED: 'FACTORY_CREATE_SUCCEEDED',
  FACTORY_CREATE_FAILED: 'FACTORY_CREATE_FAILED',
  FACTORY_CREATE_RECEIVED: 'FACTORY_CREATE_RECEIVED',
  FACTORY_UPDATE_REQUESTED: 'FACTORY_UPDATE_REQUESTED',
  FACTORY_UPDATE_SUCCEEDED: 'FACTORY_UPDATE_SUCCEEDED',
  FACTORY_UPDATE_FAILED: 'FACTORY_UPDATE_FAILED',
  FACTORY_UPDATE_RECEIVED: 'FACTORY_UPDATE_RECEIVED',
  FACTORY_BACKGROUND_IMAGE_UPDATE_REQUESTED: 'FACTORY_BACKGROUND_IMAGE_UPDATE_REQUESTED',
  FACTORY_BACKGROUND_IMAGE_UPDATE_SUCCEEDED: 'FACTORY_BACKGROUND_IMAGE_UPDATE_SUCCEEDED',
  FACTORY_BACKGROUND_IMAGE_UPDATE_FAILED: 'FACTORY_BACKGROUND_IMAGE_UPDATE_FAILED',
  FACTORY_DELETE_REQUESTED: 'FACTORY_DELETE_REQUESTED',
  FACTORY_DELETE_SUCCEEDED: 'FACTORY_DELETE_SUCCEEDED',
  FACTORY_DELETE_FAILED: 'FACTORY_DELETE_FAILED',
  FACTORY_DELETE_RECEIVED: 'FACTORY_DELETE_RECEIVED',

  /* Brand */

  BRAND_CREATE: 'BRAND_CREATE',
  BRAND_UPDATE: 'BRAND_UPDATE',
  BRAND_DELETE: 'BRAND_DELETE',
  BRAND_CREATE_REQUESTED: 'BRAND_CREATE_REQUESTED',
  BRAND_CREATE_SUCCEEDED: 'BRAND_CREATE_SUCCEEDED',
  BRAND_CREATE_FAILED: 'BRAND_CREATE_FAILED',
  BRAND_CREATE_RECEIVED: 'BRAND_CREATE_RECEIVED',
  BRAND_UPDATE_REQUESTED: 'BRAND_UPDATE_REQUESTED',
  BRAND_UPDATE_SUCCEEDED: 'BRAND_UPDATE_SUCCEEDED',
  BRAND_UPDATE_FAILED: 'BRAND_UPDATE_FAILED',
  BRAND_UPDATE_RECEIVED: 'BRAND_UPDATE_RECEIVED',
  BRAND_DELETE_REQUESTED: 'BRAND_DELETE_REQUESTED',
  BRAND_DELETE_SUCCEEDED: 'BRAND_DELETE_SUCCEEDED',
  BRAND_DELETE_FAILED: 'BRAND_DELETE_FAILED',
  BRAND_DELETE_RECEIVED: 'BRAND_DELETE_RECEIVED',

  /* Models */

  MODELS_FETCH_REQUESTED: 'MODELS_FETCH_REQUESTED',
  MODELS_FETCH_SUCCEEDED: 'MODELS_FETCH_SUCCEEDED',
  MODELS_FETCH_FAILED: 'MODELS_FETCH_FAILED',

  /* Model */

  MODEL_CREATE: 'MODEL_CREATE',
  MODEL_UPDATE: 'MODEL_UPDATE',
  MODEL_DELETE: 'MODEL_DELETE',
  MODEL_CREATE_REQUESTED: 'MODEL_CREATE_REQUESTED',
  MODEL_CREATE_SUCCEEDED: 'MODEL_CREATE_SUCCEEDED',
  MODEL_CREATE_FAILED: 'MODEL_CREATE_FAILED',
  MODEL_CREATE_RECEIVED: 'MODEL_CREATE_RECEIVED',
  MODEL_UPDATE_REQUESTED: 'MODEL_UPDATE_REQUESTED',
  MODEL_UPDATE_SUCCEEDED: 'MODEL_UPDATE_SUCCEEDED',
  MODEL_UPDATE_FAILED: 'MODEL_UPDATE_FAILED',
  MODEL_UPDATE_RECEIVED: 'MODEL_UPDATE_RECEIVED',
  MODEL_DELETE_REQUESTED: 'MODEL_DELETE_REQUESTED',
  MODEL_DELETE_SUCCEEDED: 'MODEL_DELETE_SUCCEEDED',
  MODEL_DELETE_FAILED: 'MODEL_DELETE_FAILED',
  MODEL_DELETE_RECEIVED: 'MODEL_DELETE_RECEIVED',

  /* Diagram */

  DIAGRAM_CREATE: 'DIAGRAM_CREATE',
  DIAGRAM_UPDATE: 'DIAGRAM_UPDATE',
  DIAGRAM_DELETE: 'DIAGRAM_DELETE',
  DIAGRAM_CREATE_REQUESTED: 'DIAGRAM_CREATE_REQUESTED',
  DIAGRAM_CREATE_SUCCEEDED: 'DIAGRAM_CREATE_SUCCEEDED',
  DIAGRAM_CREATE_FAILED: 'DIAGRAM_CREATE_FAILED',
  DIAGRAM_CREATE_RECEIVED: 'DIAGRAM_CREATE_RECEIVED',
  DIAGRAM_UPDATE_REQUESTED: 'DIAGRAM_UPDATE_REQUESTED',
  DIAGRAM_UPDATE_SUCCEEDED: 'DIAGRAM_UPDATE_SUCCEEDED',
  DIAGRAM_UPDATE_FAILED: 'DIAGRAM_UPDATE_FAILED',
  DIAGRAM_UPDATE_RECEIVED: 'DIAGRAM_UPDATE_RECEIVED',
  DIAGRAM_DELETE_REQUESTED: 'DIAGRAM_DELETE_REQUESTED',
  DIAGRAM_DELETE_SUCCEEDED: 'DIAGRAM_DELETE_SUCCEEDED',
  DIAGRAM_DELETE_FAILED: 'DIAGRAM_DELETE_FAILED',
  DIAGRAM_DELETE_RECEIVED: 'DIAGRAM_DELETE_RECEIVED',

  /* Protocols */

  PROTOCOLS_FETCH_REQUESTED: 'PROTOCOLS_FETCH_REQUESTED',
  PROTOCOLS_FETCH_SUCCEEDED: 'PROTOCOLS_FETCH_SUCCEEDED',
  PROTOCOLS_FETCH_FAILED: 'PROTOCOLS_FETCH_FAILED',

  /* Protocol */

  PROTOCOL_CREATE: 'PROTOCOL_CREATE',
  PROTOCOL_UPDATE: 'PROTOCOL_UPDATE',
  PROTOCOL_DELETE: 'PROTOCOL_DELETE',
  PROTOCOL_CREATE_REQUESTED: 'PROTOCOL_CREATE_REQUESTED',
  PROTOCOL_CREATE_SUCCEEDED: 'PROTOCOL_CREATE_SUCCEEDED',
  PROTOCOL_CREATE_FAILED: 'PROTOCOL_CREATE_FAILED',
  PROTOCOL_CREATE_RECEIVED: 'PROTOCOL_CREATE_RECEIVED',
  PROTOCOL_UPDATE_REQUESTED: 'PROTOCOL_UPDATE_REQUESTED',
  PROTOCOL_UPDATE_SUCCEEDED: 'PROTOCOL_UPDATE_SUCCEEDED',
  PROTOCOL_UPDATE_FAILED: 'PROTOCOL_UPDATE_FAILED',
  PROTOCOL_UPDATE_RECEIVED: 'PROTOCOL_UPDATE_RECEIVED',
  PROTOCOL_DELETE_REQUESTED: 'PROTOCOL_DELETE_REQUESTED',
  PROTOCOL_DELETE_SUCCEEDED: 'PROTOCOL_DELETE_SUCCEEDED',
  PROTOCOL_DELETE_FAILED: 'PROTOCOL_DELETE_FAILED',
  PROTOCOL_DELETE_RECEIVED: 'PROTOCOL_DELETE_RECEIVED',

  /* Alerts */

  ALERTS_FETCH_REQUESTED: 'ALERTS_FETCH_REQUESTED',
  ALERTS_FETCH_SUCCEEDED: 'ALERTS_FETCH_SUCCEEDED',
  ALERTS_FETCH_FAILED: 'ALERTS_FETCH_FAILED',
  ALERTS_OCCUR_FETCH_REQUESTED: 'ALERTS_OCCUR_FETCH_REQUESTED',
  ALERTS_OCCUR_FETCH_SUCCEEDED: 'ALERTS_OCCUR_FETCH_SUCCEEDED',
  ALERTS_OCCUR_FETCH_FAILED: 'ALERTS_OCCUR_FETCH_FAILED',
  ALERTS_RES_FETCH_REQUESTED: 'ALERTS_RES_FETCH_REQUESTED',
  ALERTS_RES_FETCH_SUCCEEDED: 'ALERTS_RES_FETCH_SUCCEEDED',
  ALERTS_RES_FETCH_FAILED: 'ALERTS_RES_FETCH_FAILED',

  ALERT_DATA_FETCH_REQUESTED: 'ALERT_DATA_FETCH_REQUESTED',
  ALERT_DATA_FETCH_SUCCEEDED: 'ALERT_DATA_FETCH_SUCCEEDED',
  ALERT_DATA_FETCH_FAILED: 'ALERT_DATA_FETCH_FAILED',

  /* Alerts Setting */

  ALERTS_SETTING_FETCH_REQUESTED: 'ALERTS_SETTING_FETCH_REQUESTED',
  ALERTS_SETTING_FETCH_SUCCEEDED: 'ALERTS_SETTING_FETCH_SUCCEEDED',
  ALERTS_SETTING_FETCH_FAILED: 'ALERTS_SETTING_FETCH_FAILED',

  ALERT_SETTING_CREATE: 'ALERT_SETTING_CREATE',
  ALERT_SETTING_UPDATE: 'ALERT_SETTING_UPDATE',
  ALERT_SETTING_DELETE: 'ALERT_SETTING_DELETE',
  ALERT_SETTING_CREATE_REQUESTED: 'ALERT_SETTING_CREATE_REQUESTED',
  ALERT_SETTING_CREATE_SUCCEEDED: 'ALERT_SETTING_CREATE_SUCCEEDED',
  ALERT_SETTING_CREATE_FAILED: 'ALERT_SETTING_CREATE_FAILED',
  ALERT_SETTING_CREATE_RECEIVED: 'ALERT_SETTING_CREATE_RECEIVED',
  ALERT_SETTING_UPDATE_REQUESTED: 'ALERT_SETTING_UPDATE_REQUESTED',
  ALERT_SETTING_UPDATE_SUCCEEDED: 'ALERT_SETTING_UPDATE_SUCCEEDED',
  ALERT_SETTING_UPDATE_FAILED: 'ALERT_SETTING_UPDATE_FAILED',
  ALERT_SETTING_UPDATE_RECEIVED: 'ALERT_SETTING_UPDATE_RECEIVED',
  ALERT_SETTING_DELETE_REQUESTED: 'ALERT_SETTING_DELETE_REQUESTED',
  ALERT_SETTING_DELETE_SUCCEEDED: 'ALERT_SETTING_DELETE_SUCCEEDED',
  ALERT_SETTING_DELETE_FAILED: 'ALERT_SETTING_DELETE_FAILED',
  ALERT_SETTING_DELETE_RECEIVED: 'ALERT_SETTING_DELETE_RECEIVED',

  /* Channels */

  CHANNELS_FETCH_REQUESTED: 'CHANNELS_FETCH_REQUESTED',
  CHANNELS_FETCH_SUCCEEDED: 'CHANNELS_FETCH_SUCCEEDED',
  CHANNELS_FETCH_FAILED: 'CHANNELS_FETCH_FAILED',

  /* Channel */

  CHANNEL_CREATE: 'CHANNEL_CREATE',
  CHANNEL_UPDATE: 'CHANNEL_UPDATE',
  CHANNEL_DELETE: 'CHANNEL_DELETE',
  CHANNEL_CREATE_REQUESTED: 'CHANNEL_CREATE_REQUESTED',
  CHANNEL_CREATE_SUCCEEDED: 'CHANNEL_CREATE_SUCCEEDED',
  CHANNEL_CREATE_FAILED: 'CHANNEL_CREATE_FAILED',
  CHANNEL_CREATE_RECEIVED: 'CHANNEL_CREATE_RECEIVED',
  CHANNEL_UPDATE_REQUESTED: 'CHANNEL_UPDATE_REQUESTED',
  CHANNEL_UPDATE_SUCCEEDED: 'CHANNEL_UPDATE_SUCCEEDED',
  CHANNEL_UPDATE_FAILED: 'CHANNEL_UPDATE_FAILED',
  CHANNEL_UPDATE_RECEIVED: 'CHANNEL_UPDATE_RECEIVED',
  CHANNEL_DELETE_REQUESTED: 'CHANNEL_DELETE_REQUESTED',
  CHANNEL_DELETE_SUCCEEDED: 'CHANNEL_DELETE_SUCCEEDED',
  CHANNEL_DELETE_FAILED: 'CHANNEL_DELETE_FAILED',
  CHANNEL_DELETE_RECEIVED: 'CHANNEL_DELETE_RECEIVED',

  /* Items */

  ITEMS_FETCH_REQUESTED: 'ITEMS_FETCH_REQUESTED',
  ITEMS_FETCH_SUCCEEDED: 'ITEMS_FETCH_SUCCEEDED',
  ITEMS_FETCH_FAILED: 'ITEMS_FETCH_FAILED',
  ITEMS_UPDATE_RECEIVED: 'ITEMS_UPDATE_RECEIVED',

  /* Item */

  ITEM_CREATE: 'ITEM_CREATE',
  ITEM_UPDATE: 'ITEM_UPDATE',
  ITEM_DELETE: 'ITEM_DELETE',
  ITEM_CREATE_REQUESTED: 'ITEM_CREATE_REQUESTED',
  ITEM_CREATE_SUCCEEDED: 'ITEM_CREATE_SUCCEEDED',
  ITEM_CREATE_FAILED: 'ITEM_CREATE_FAILED',
  ITEM_CREATE_RECEIVED: 'ITEM_CREATE_RECEIVED',
  ITEM_UPDATE_REQUESTED: 'ITEM_UPDATE_REQUESTED',
  ITEM_UPDATE_SUCCEEDED: 'ITEM_UPDATE_SUCCEEDED',
  ITEM_UPDATE_FAILED: 'ITEM_UPDATE_FAILED',
  ITEM_UPDATE_RECEIVED: 'ITEM_UPDATE_RECEIVED',
  ITEM_DELETE_REQUESTED: 'ITEM_DELETE_REQUESTED',
  ITEM_DELETE_SUCCEEDED: 'ITEM_DELETE_SUCCEEDED',
  ITEM_DELETE_FAILED: 'ITEM_DELETE_FAILED',
  ITEM_DELETE_RECEIVED: 'ITEM_DELETE_RECEIVED',

  /* Reports */

  DAILY_REPORTS_FETCH_REQUESTED: 'DAILY_REPORTS_FETCH_REQUESTED',
  DAILY_REPORTS_FETCH_SUCCEEDED: 'DAILY_REPORTS_FETCH_SUCCEEDED',
  DAILY_REPORTS_FETCH_FAILED: 'DAILY_REPORTS_FETCH_FAILED',
  MONTHLY_REPORTS_FETCH_REQUESTED: 'MONTHLY_REPORTS_FETCH_REQUESTED',
  MONTHLY_REPORTS_FETCH_SUCCEEDED: 'MONTHLY_REPORTS_FETCH_SUCCEEDED',
  MONTHLY_REPORTS_FETCH_FAILED: 'MONTHLY_REPORTS_FETCH_FAILED',
  YEARLY_REPORTS_FETCH_REQUESTED: 'YEARLY_REPORTS_FETCH_REQUESTED',
  YEARLY_REPORTS_FETCH_SUCCEEDED: 'YEARLY_REPORTS_FETCH_SUCCEEDED',
  YEARLY_REPORTS_FETCH_FAILED: 'YEARLY_REPORTS_FETCH_FAILED',

  /* Factory membership */

  FACTORY_MEMBERSHIP_CREATE: 'FACTORY_MEMBERSHIP_CREATE',
  FACTORY_MEMBERSHIP_DELETE: 'FACTORY_MEMBERSHIP_DELETE',
  FACTORY_MEMBERSHIP_CREATE_REQUESTED: 'FACTORY_MEMBERSHIP_CREATE_REQUESTED',
  FACTORY_MEMBERSHIP_CREATE_SUCCEEDED: 'FACTORY_MEMBERSHIP_CREATE_SUCCEEDED',
  FACTORY_MEMBERSHIP_CREATE_FAILED: 'FACTORY_MEMBERSHIP_CREATE_FAILED',
  FACTORY_MEMBERSHIP_CREATE_RECEIVED: 'FACTORY_MEMBERSHIP_CREATE_RECEIVED',
  FACTORY_MEMBERSHIP_DELETE_REQUESTED: 'FACTORY_MEMBERSHIP_DELETE_REQUESTED',
  FACTORY_MEMBERSHIP_DELETE_SUCCEEDED: 'FACTORY_MEMBERSHIP_DELETE_SUCCEEDED',
  FACTORY_MEMBERSHIP_DELETE_FAILED: 'FACTORY_MEMBERSHIP_DELETE_FAILED',
  FACTORY_MEMBERSHIP_DELETE_RECEIVED: 'FACTORY_MEMBERSHIP_DELETE_RECEIVED',

  /* Site */

  SITE_CREATE: 'SITE_CREATE',
  SITE_UPDATE: 'SITE_UPDATE',
  SITE_DELETE: 'SITE_DELETE',
  SITE_CREATE_REQUESTED: 'SITE_CREATE_REQUESTED',
  SITE_CREATE_SUCCEEDED: 'SITE_CREATE_SUCCEEDED',
  SITE_CREATE_FAILED: 'SITE_CREATE_FAILED',
  SITE_CREATE_RECEIVED: 'SITE_CREATE_RECEIVED',
  SITE_FETCH_REQUESTED: 'SITE_FETCH_REQUESTED',
  SITE_FETCH_SUCCEEDED: 'SITE_FETCH_SUCCEEDED',
  SITE_FETCH_FAILED: 'SITE_FETCH_FAILED',
  SITE_UPDATE_REQUESTED: 'SITE_UPDATE_REQUESTED',
  SITE_UPDATE_SUCCEEDED: 'SITE_UPDATE_SUCCEEDED',
  SITE_UPDATE_FAILED: 'SITE_UPDATE_FAILED',
  SITE_UPDATE_RECEIVED: 'SITE_UPDATE_RECEIVED',
  SITE_DELETE_REQUESTED: 'SITE_DELETE_REQUESTED',
  SITE_DELETE_SUCCEEDED: 'SITE_DELETE_SUCCEEDED',
  SITE_DELETE_FAILED: 'SITE_DELETE_FAILED',
  SITE_DELETE_RECEIVED: 'SITE_DELETE_RECEIVED',

  /* Label */

  LABEL_CREATE: 'LABEL_CREATE',
  LABEL_UPDATE: 'LABEL_UPDATE',
  LABEL_DELETE: 'LABEL_DELETE',
  LABEL_TO_DEVICE_ADD: 'LABEL_TO_DEVICE_ADD',
  LABEL_FROM_DEVICE_REMOVE: 'LABEL_FROM_DEVICE_REMOVE',
  LABEL_TO_SITE_FILTER_ADD: 'LABEL_TO_SITE_FILTER_ADD',
  LABEL_FROM_SITE_FILTER_REMOVE: 'LABEL_FROM_SITE_FILTER_REMOVE',
  LABEL_CREATE_REQUESTED: 'LABEL_CREATE_REQUESTED',
  LABEL_CREATE_SUCCEEDED: 'LABEL_CREATE_SUCCEEDED',
  LABEL_CREATE_FAILED: 'LABEL_CREATE_FAILED',
  LABEL_CREATE_RECEIVED: 'LABEL_CREATE_RECEIVED',
  LABEL_UPDATE_REQUESTED: 'LABEL_UPDATE_REQUESTED',
  LABEL_UPDATE_SUCCEEDED: 'LABEL_UPDATE_SUCCEEDED',
  LABEL_UPDATE_FAILED: 'LABEL_UPDATE_FAILED',
  LABEL_UPDATE_RECEIVED: 'LABEL_UPDATE_RECEIVED',
  LABEL_DELETE_REQUESTED: 'LABEL_DELETE_REQUESTED',
  LABEL_DELETE_SUCCEEDED: 'LABEL_DELETE_SUCCEEDED',
  LABEL_DELETE_FAILED: 'LABEL_DELETE_FAILED',
  LABEL_DELETE_RECEIVED: 'LABEL_DELETE_RECEIVED',

  /* Line */

  LINE_CREATE: 'LINE_CREATE',
  LINE_UPDATE: 'LINE_UPDATE',
  LINE_DELETE: 'LINE_DELETE',
  LINE_CREATE_REQUESTED: 'LINE_CREATE_REQUESTED',
  LINE_CREATE_SUCCEEDED: 'LINE_CREATE_SUCCEEDED',
  LINE_CREATE_FAILED: 'LINE_CREATE_FAILED',
  LINE_CREATE_RECEIVED: 'LINE_CREATE_RECEIVED',
  LINE_UPDATE_REQUESTED: 'LINE_UPDATE_REQUESTED',
  LINE_UPDATE_SUCCEEDED: 'LINE_UPDATE_SUCCEEDED',
  LINE_UPDATE_FAILED: 'LINE_UPDATE_FAILED',
  LINE_UPDATE_RECEIVED: 'LINE_UPDATE_RECEIVED',
  LINE_DELETE_REQUESTED: 'LINE_DELETE_REQUESTED',
  LINE_DELETE_SUCCEEDED: 'LINE_DELETE_SUCCEEDED',
  LINE_DELETE_FAILED: 'LINE_DELETE_FAILED',
  LINE_DELETE_RECEIVED: 'LINE_DELETE_RECEIVED',

  /* Device */

  DEVICE_CREATE: 'DEVICE_CREATE',
  DEVICE_UPDATE: 'DEVICE_UPDATE',
  DEVICE_HIDE: 'DEVICE_HIDE',
  DEVICE_DELETE: 'DEVICE_DELETE',
  DEVICE_CREATE_REQUESTED: 'DEVICE_CREATE_REQUESTED',
  DEVICE_CREATE_SUCCEEDED: 'DEVICE_CREATE_SUCCEEDED',
  DEVICE_CREATE_FAILED: 'DEVICE_CREATE_FAILED',
  DEVICE_CREATE_RECEIVED: 'DEVICE_CREATE_RECEIVED',
  DEVICE_FETCH_REQUESTED: 'DEVICE_FETCH_REQUESTED',
  DEVICE_FETCH_SUCCEEDED: 'DEVICE_FETCH_SUCCEEDED',
  DEVICE_FETCH_FAILED: 'DEVICE_FETCH_FAILED',
  DEVICE_UPDATE_REQUESTED: 'DEVICE_UPDATE_REQUESTED',
  DEVICE_UPDATE_SUCCEEDED: 'DEVICE_UPDATE_SUCCEEDED',
  DEVICE_UPDATE_FAILED: 'DEVICE_UPDATE_FAILED',
  DEVICE_UPDATE_RECEIVED: 'DEVICE_UPDATE_RECEIVED',
  DEVICE_DELETE_REQUESTED: 'DEVICE_DELETE_REQUESTED',
  DEVICE_DELETE_SUCCEEDED: 'DEVICE_DELETE_SUCCEEDED',
  DEVICE_DELETE_FAILED: 'DEVICE_DELETE_FAILED',
  DEVICE_DELETE_RECEIVED: 'DEVICE_DELETE_RECEIVED',
  DEVICE_HIDE_REQUESTED: 'DEVICE_HIDE_REQUESTED',
  DEVICE_HIDE_SUCCEEDED: 'DEVICE_HIDE_SUCCEEDED',
  DEVICE_HIDE_FAILED: 'DEVICE_HIDE_FAILED',
  DEVICE_HIDE_RECEIVED: 'DEVICE_HIDE_RECEIVED',
  DEVICE_ITEMS_UPDATE_RECEIVED: 'DEVICE_ITEMS_UPDATE_RECEIVED',
  DEVICE_COMMON_UPDATE: 'DEVICE_COMMON_UPDATE',
  DEVICE_COMMON_UPDATE_REQUESTED: 'DEVICE_COMMON_UPDATE_REQUESTED',
  DEVICE_COMMON_UPDATE_SUCCEEDED: 'DEVICE_COMMON_UPDATE_SUCCEEDED',
  DEVICE_COMMON_UPDATE_FAILED: 'DEVICE_COMMON_UPDATE_FAILED',
  DEVICE_COMMON_UPDATE_RECEIVED: 'DEVICE_COMMON_UPDATE_RECEIVED',

  ALL_DEVICES_FETCH_REQUESTED: 'ALL_DEVICES_FETCH_REQUESTED',
  ALL_DEVICES_FETCH_SUCCEEDED: 'ALL_DEVICES_FETCH_SUCCEEDED',
  ALL_DEVICES_FETCH_FAILED: 'ALL_DEVICES_FETCH_FAILED',

  DATAS_REALTIME_FETCH_REQUESTED: 'DATAS_REALTIME_FETCH_REQUESTED',
  DATAS_REALTIME_FETCH_SUCCEEDED: 'DATAS_REALTIME_FETCH_SUCCEEDED',
  DATAS_REALTIME_FETCH_FAILED: 'DATAS_REALTIME_FETCH_FAILED',

  /* Device membership */

  DEVICE_MEMBERSHIP_CREATE_REQUESTED: 'DEVICE_MEMBERSHIP_CREATE_REQUESTED',
  DEVICE_MEMBERSHIP_CREATE_SUCCEEDED: 'DEVICE_MEMBERSHIP_CREATE_SUCCEEDED',
  DEVICE_MEMBERSHIP_CREATE_FAILED: 'DEVICE_MEMBERSHIP_CREATE_FAILED',
  DEVICE_MEMBERSHIP_CREATE_RECEIVED: 'DEVICE_MEMBERSHIP_CREATE_RECEIVED',
  DEVICE_MEMBERSHIP_DELETE_REQUESTED: 'DEVICE_MEMBERSHIP_DELETE_REQUESTED',
  DEVICE_MEMBERSHIP_DELETE_SUCCEEDED: 'DEVICE_MEMBERSHIP_DELETE_SUCCEEDED',
  DEVICE_MEMBERSHIP_DELETE_FAILED: 'DEVICE_MEMBERSHIP_DELETE_FAILED',
  DEVICE_MEMBERSHIP_DELETE_RECEIVED: 'DEVICE_MEMBERSHIP_DELETE_RECEIVED',

  /* Device label */

  DEVICE_LABEL_CREATE_REQUESTED: 'DEVICE_LABEL_CREATE_REQUESTED',
  DEVICE_LABEL_CREATE_SUCCEEDED: 'DEVICE_LABEL_CREATE_SUCCEEDED',
  DEVICE_LABEL_CREATE_FAILED: 'DEVICE_LABEL_CREATE_FAILED',
  DEVICE_LABEL_CREATE_RECEIVED: 'DEVICE_LABEL_CREATE_RECEIVED',
  DEVICE_LABEL_DELETE_REQUESTED: 'DEVICE_LABEL_DELETE_REQUESTED',
  DEVICE_LABEL_DELETE_SUCCEEDED: 'DEVICE_LABEL_DELETE_SUCCEEDED',
  DEVICE_LABEL_DELETE_FAILED: 'DEVICE_LABEL_DELETE_FAILED',
  DEVICE_LABEL_DELETE_RECEIVED: 'DEVICE_LABEL_DELETE_RECEIVED',

  /* Alarm */

  ALARM_CREATE: 'ALARM_CREATE',
  ALARM_UPDATE: 'ALARM_UPDATE',
  ALARM_DELETE: 'ALARM_DELETE',
  ALARM_CREATE_REQUESTED: 'ALARM_CREATE_REQUESTED',
  ALARM_CREATE_SUCCEEDED: 'ALARM_CREATE_SUCCEEDED',
  ALARM_CREATE_FAILED: 'ALARM_CREATE_FAILED',
  ALARM_CREATE_RECEIVED: 'ALARM_CREATE_RECEIVED',
  ALARM_UPDATE_REQUESTED: 'ALARM_UPDATE_REQUESTED',
  ALARM_UPDATE_SUCCEEDED: 'ALARM_UPDATE_SUCCEEDED',
  ALARM_UPDATE_FAILED: 'ALARM_UPDATE_FAILED',
  ALARM_UPDATE_RECEIVED: 'ALARM_UPDATE_RECEIVED',
  ALARM_DELETE_REQUESTED: 'ALARM_DELETE_REQUESTED',
  ALARM_DELETE_SUCCEEDED: 'ALARM_DELETE_SUCCEEDED',
  ALARM_DELETE_FAILED: 'ALARM_DELETE_FAILED',
  ALARM_DELETE_RECEIVED: 'ALARM_DELETE_RECEIVED',

  /* Attachment */

  ATTACHMENT_CREATE: 'ATTACHMENT_CREATE',
  ATTACHMENT_UPDATE: 'ATTACHMENT_UPDATE',
  ATTACHMENT_DELETE: 'ATTACHMENT_DELETE',
  ATTACHMENT_CREATE_REQUESTED: 'ATTACHMENT_CREATE_REQUESTED',
  ATTACHMENT_CREATE_SUCCEEDED: 'ATTACHMENT_CREATE_SUCCEEDED',
  ATTACHMENT_CREATE_FAILED: 'ATTACHMENT_CREATE_FAILED',
  ATTACHMENT_CREATE_RECEIVED: 'ATTACHMENT_CREATE_RECEIVED',
  ATTACHMENT_UPDATE_REQUESTED: 'ATTACHMENT_UPDATE_REQUESTED',
  ATTACHMENT_UPDATE_SUCCEEDED: 'ATTACHMENT_UPDATE_SUCCEEDED',
  ATTACHMENT_UPDATE_FAILED: 'ATTACHMENT_UPDATE_FAILED',
  ATTACHMENT_UPDATE_RECEIVED: 'ATTACHMENT_UPDATE_RECEIVED',
  ATTACHMENT_DELETE_REQUESTED: 'ATTACHMENT_DELETE_REQUESTED',
  ATTACHMENT_DELETE_SUCCEEDED: 'ATTACHMENT_DELETE_SUCCEEDED',
  ATTACHMENT_DELETE_FAILED: 'ATTACHMENT_DELETE_FAILED',
  ATTACHMENT_DELETE_RECEIVED: 'ATTACHMENT_DELETE_RECEIVED',

  /* Architecture */

  ARCHITECTURE_CREATE: 'ARCHITECTURE_CREATE',
  ARCHITECTURE_DELETE: 'ARCHITECTURE_DELETE',
  ARCHITECTURE_FETCH: 'ARCHITECTURE_FETCH',
  ARCHITECTURE_CREATE_REQUESTED: 'ARCHITECTURE_CREATE_REQUESTED',
  ARCHITECTURE_CREATE_SUCCEEDED: 'ARCHITECTURE_CREATE_SUCCEEDED',
  ARCHITECTURE_CREATE_FAILED: 'ARCHITECTURE_CREATE_FAILED',
  ARCHITECTURE_CREATE_RECEIVED: 'ARCHITECTURE_CREATE_RECEIVED',
  ARCHITECTURE_DELETE_REQUESTED: 'ARCHITECTURE_DELETE_REQUESTED',
  ARCHITECTURE_DELETE_SUCCEEDED: 'ARCHITECTURE_DELETE_SUCCEEDED',
  ARCHITECTURE_DELETE_FAILED: 'ARCHITECTURE_DELETE_FAILED',
  ARCHITECTURE_DELETE_RECEIVED: 'ARCHITECTURE_DELETE_RECEIVED',
  ARCHITECTURE_FETCH_REQUESTED: 'ARCHITECTURE_FETCH_REQUESTED',
  ARCHITECTURE_FETCH_SUCCEEDED: 'ARCHITECTURE_FETCH_SUCCEEDED',
  ARCHITECTURE_FETCH_FAILED: 'ARCHITECTURE_FETCH_FAILED',
  ARCHITECTURE_FETCH_RECEIVED: 'ARCHITECTURE_FETCH_RECEIVED',

  /* Actions */

  ACTIONS_FETCH_REQUESTED: 'ACTIONS_FETCH_REQUESTED',
  ACTIONS_FETCH_SUCCEEDED: 'ACTIONS_FETCH_SUCCEEDED',
  ACTIONS_FETCH_FAILED: 'ACTIONS_FETCH_FAILED',

  /* Action */

  ACTION_CREATE_RECEIVED: 'ACTION_CREATE_RECEIVED',
  ACTION_UPDATE_RECEIVED: 'ACTION_UPDATE_RECEIVED',
  ACTION_DELETE_RECEIVED: 'ACTION_DELETE_RECEIVED',

  /* Comment action */

  COMMENT_ACTION_CREATE: 'COMMENT_ACTION_CREATE',
  COMMENT_ACTION_UPDATE: 'COMMENT_ACTION_UPDATE',
  COMMENT_ACTION_DELETE: 'COMMENT_ACTION_DELETE',
  COMMENT_ACTION_CREATE_REQUESTED: 'COMMENT_ACTION_CREATE_REQUESTED',
  COMMENT_ACTION_CREATE_SUCCEEDED: 'COMMENT_ACTION_CREATE_SUCCEEDED',
  COMMENT_ACTION_CREATE_FAILED: 'COMMENT_ACTION_CREATE_FAILED',
  COMMENT_ACTION_UPDATE_REQUESTED: 'COMMENT_ACTION_UPDATE_REQUESTED',
  COMMENT_ACTION_UPDATE_SUCCEEDED: 'COMMENT_ACTION_UPDATE_SUCCEEDED',
  COMMENT_ACTION_UPDATE_FAILED: 'COMMENT_ACTION_UPDATE_FAILED',
  COMMENT_ACTION_DELETE_REQUESTED: 'COMMENT_ACTION_DELETE_REQUESTED',
  COMMENT_ACTION_DELETE_SUCCEEDED: 'COMMENT_ACTION_DELETE_SUCCEEDED',
  COMMENT_ACTION_DELETE_FAILED: 'COMMENT_ACTION_DELETE_FAILED',

  /* Notifications */

  NOTIFICATIONS_DELETE: 'NOTIFICATIONS_DELETE',
  NOTIFICATIONS_FETCH_REQUESTED: 'NOTIFICATIONS_FETCH_REQUESTED',
  NOTIFICATIONS_FETCH_SUCCEEDED: 'NOTIFICATIONS_FETCH_SUCCEEDED',
  NOTIFICATIONS_FETCH_FAILED: 'NOTIFICATIONS_FETCH_FAILED',
  NOTIFICATIONS_DELETE_REQUESTED: 'NOTIFICATIONS_DELETE_REQUESTED',
  NOTIFICATIONS_DELETE_SUCCEEDED: 'NOTIFICATIONS_DELETE_SUCCEEDED',
  NOTIFICATIONS_DELETE_FAILED: 'NOTIFICATIONS_DELETE_FAILED',

  /* Notification */

  NOTIFICATION_CREATE_RECEIVED: 'NOTIFICATION_CREATE_RECEIVED',
  NOTIFICATION_DELETE_RECEIVED: 'NOTIFICATION_DELETE_RECEIVED',

  /* Invoices */
  INVOICES_ELECTRICITY_FETCH_REQUESTED: 'INVOICES_ELECTRICITY_FETCH_REQUESTED',
  INVOICES_ELECTRICITY_FETCH_SUCCEEDED: 'INVOICES_ELECTRICITY_FETCH_SUCCEEDED',
  INVOICES_ELECTRICITY_FETCH_FAILED: 'INVOICES_ELECTRICITY_FETCH_FAILED',
  INVOICES_GAS_FETCH_REQUESTED: 'INVOICES_GAS_FETCH_REQUESTED',
  INVOICES_GAS_FETCH_SUCCEEDED: 'INVOICES_GAS_FETCH_SUCCEEDED',
  INVOICES_GAS_FETCH_FAILED: 'INVOICES_GAS_FETCH_FAILED',
  INVOICES_WATER_FETCH_REQUESTED: 'INVOICES_WATER_FETCH_REQUESTED',
  INVOICES_WATER_FETCH_SUCCEEDED: 'INVOICES_WATER_FETCH_SUCCEEDED',
  INVOICES_WATER_FETCH_FAILED: 'INVOICES_WATER_FETCH_FAILED',

  /* Setting Prices */
  SETTING_PRICE_CREATE: 'SETTING_PRICE_CREATE',
  SETTING_PRICE_UPDATE: 'SETTING_PRICE_UPDATE',
  SETTING_PRICE_CREATE_REQUESTED: 'SETTING_PRICE_CREATE_REQUESTED',
  SETTING_PRICE_CREATE_SUCCEEDED: 'SETTING_PRICE_CREATE_SUCCEEDED',
  SETTING_PRICE_CREATE_FAILED: 'SETTING_PRICE_CREATE_FAILED',
  SETTING_PRICE_CREATE_RECEIVED: 'SETTING_PRICE_CREATE_RECEIVED',
  SETTING_PRICE_UPDATE_REQUESTED: 'SETTING_PRICE_UPDATE_REQUESTED',
  SETTING_PRICE_UPDATE_FAILED: 'SETTING_PRICE_UPDATE_FAILED',
  SETTING_PRICE_UPDATE_SUCCEEDED: 'SETTING_PRICE_UPDATE_SUCCEEDED',
  SETTING_PRICE_UPDATE_RECEIVED: 'SETTING_PRICE_UPDATE_RECEIVED',

  SETTING_PRICES_FETCH_REQUESTED: 'SETTING_PRICES_FETCH_REQUESTED',
  SETTING_PRICES_FETCH_SUCCEEDED: 'SETTING_PRICES_FETCH_SUCCEEDED',
  SETTING_PRICES_FETCH_FAILED: 'SETTING_PRICES_FETCH_FAILED',

  /* Component Dashboard */
  COMPONENT_CREATE: 'COMPONENT_CREATE',
  COMPONENT_CREATE_REQUESTED: 'COMPONENT_CREATE_REQUESTED',
  COMPONENT_CREATE_SUCCESSDED: 'COMPONENT_CREATE_SUCCESSDED',
  COMPONENT_CREATE_FAILED: 'COMPONENT_CREATE_FAILED',
  COMPONENT_CREATE_RECEIVED: 'COMPONENT_CREATE_RECEIVED',
  COMPONENT_UPDATE: 'COMPONENT_UPDATE',
  COMPONENT_UPDATE_REQUESTED: 'COMPONENT_UPDATE_REQUESTED',
  COMPONENT_UPDATE_SUCCESSDED: 'COMPONENT_UPDATE_SUCCESSDED',
  COMPONENT_UPDATE_FAILED: 'COMPONENT_UPDATE_FAILED',
  COMPONENT_UPDATE_RECEIVED: 'COMPONENT_UPDATE_RECEIVED',
  COMPONENT_DELETE_RECEIVED: 'COMPONENT_DELETE_RECEIVED',
  COMPONENT_DELETE: 'COMPONENT_DELETE',
  COMPONENT_DELETE_REQUESTED: 'COMPONENT_DELETE_REQUESTED',
  COMPONENT_DELETE_FAILED: 'COMPONENT_DELETE_FAILED',
  COMPONENT_DELETE_SUCCESSDED: 'COMPONENT_DELETE_SUCCESSDED',

  /* System */
  REBOOT_SYSTEM_REQUESTED: 'REBOOT_SYSTEM_REQUESTED',
  REBOOT_SYSTEM_SUCCEEDED: 'REBOOT_SYSTEM_SUCCEEDED',
  REBOOT_SYSTEM_FAILED: 'REBOOT_SYSTEM_FAILED',
  SYSTEM_ERROR_CLEAR: 'SYSTEM_ERROR_CLEAR',

  /* Setting emails */
  SETTING_EMAILS_CREATE: 'SETTING_EMAILS_CREATE',
  SETTING_EMAILS_UPDATE: 'SETTING_EMAILS_UPDATE',
  SETTING_EMAILS_CREATE_REQUESTED: 'SETTING_EMAILS_CREATE_REQUESTED',
  SETTING_EMAILS_CREATE_SUCCEEDED: 'SETTING_EMAILS_CREATE_SUCCEEDED',
  SETTING_EMAILS_CREATE_FAILED: 'SETTING_EMAILS_CREATE_FAILED',
  SETTING_EMAILS_CREATE_RECEIVED: 'SETTING_EMAILS_CREATE_RECEIVED',
  SETTING_EMAILS_UPDATE_REQUESTED: 'SETTING_EMAILS_UPDATE_REQUESTED',
  SETTING_EMAILS_UPDATE_FAILED: 'SETTING_EMAILS_UPDATE_FAILED',
  SETTING_EMAILS_UPDATE_SUCCEEDED: 'SETTING_EMAILS_UPDATE_SUCCEEDED',
  SETTING_EMAILS_UPDATE_RECEIVED: 'SETTING_EMAILS_UPDATE_RECEIVED',

  SETTING_EMAILS_FETCH_REQUESTED: 'SETTING_EMAILS_FETCH_REQUESTED',
  SETTING_EMAILS_FETCH_SUCCEEDED: 'SETTING_EMAILS_FETCH_SUCCEEDED',
  SETTING_EMAILS_FETCH_FAILED: 'SETTING_EMAILS_FETCH_FAILED',

  SETTING_ERROR_CLEAR: 'SETTING_ERROR_CLEAR',
};
